import { Input, Directive, ViewChild, Output, EventEmitter, HostListener, ElementRef, OnDestroy, OutputRefSubscription, OnInit } from '@angular/core';
import { BsDropdownDirective } from 'ngx-bootstrap/dropdown';

const baseMenus = [];

@Directive({
	selector: 'vb-base-menu',
	standalone: false
})
export class VbBaseMenuComponent implements OnInit, OnDestroy {
	@Input() public translations: Record<string, string>;
	@Input() public isSmallSizePlayer: boolean;
	@Output() public menuCollapsed: EventEmitter<any> = new EventEmitter<any>();

	private timeoutRef: number;
	private focusedIndex: number;
	private bSubscription: OutputRefSubscription;

	@ViewChild('dropdown')
	public set dropdownViewChild(val) {
		this.dropdown = val;
		this.bSubscription?.unsubscribe();
		this.bSubscription = this.dropdown?.isOpenChange.subscribe(isOpened => {
			this.onMenuOpenChange(isOpened);
		});
	}

	public dropdown: BsDropdownDirective;

	@ViewChild('vbDropdownMenu')
	public dropdownMenu: ElementRef;

	@HostListener('mouseleave', ['$event'])
	public onMouseLeave(_$event): void {
		if (!this.dropdown.isOpen) {
			return;
		}
		this.timeoutRef = window.setTimeout(() => {
			this.hideMenu(true);
		}, 3000);
	}

	@HostListener('mouseenter', ['$event'])
	public onMouseEnter(_$event): void {
		window.clearTimeout(this.timeoutRef);
		this.timeoutRef = null;
	}

	public ngOnInit(): void {
		baseMenus.push(this);
	}

	public ngOnDestroy(): void {
		this.bSubscription?.unsubscribe();
		baseMenus.splice(baseMenus.indexOf(this), 1);
	}

	public hideMenu(closeParent?: boolean): void {
		this.dropdown.hide();

		this.menuCollapsed.emit({ closeParent });
	}

	public toggleDropdown(): void {
		for(const menu of baseMenus) {
			menu.dropdown.toggle(menu === this);
		}
	}

	public onMenuOpenChange(isOpened: boolean): void {
		this.focusedIndex = 0;
		if (isOpened) {
			this.focusFirstMenuItem();
		}
	}


	public focusFirstMenuItem(): void {
		window.setTimeout(() => {
			this.dropdownMenu.nativeElement.focus();
		}, 200);
	}
}

//Combines class names from multiple sheets by concatenating them with a space.
export function mergeStyles<T1,T2>(a: T1, b: T2): T1 & T2;
export function mergeStyles(...styleSheets: any[]): any {
	const acc = {} as any;
	for(const styles of styleSheets) {
		for(const className of Object.keys(styles)) {
			const old = acc[className];
			const newStyle = styles[className];
			acc[className] = old ? old + ' ' + newStyle : newStyle;
		}
	}
	return acc;
}
